export interface BunddleTextType {
    parentVariantId?: string;
    subs?: BundleItemType[];
    type?: 'bundle' | 'customize';
    link_buy?: string;
    name?: string;
    power?: string;
    desc?: string;
    quantity?: number;
    tip?: string;
}

export interface BundleItemType extends BunddleTextType {
    variantId?: string;
    productId?: string;
    sku?: string;
    inventoryQuantity?: number;
    inventoryPolicy?: string;
    price?: number;
    compareAtPrice?: number;
    img?: string;
    variantImg?: string;
    productTitle?: string;
    skuTitle?: string;
    handle?: string;
}

export interface BundleIdsType {
    [key: string]: BundleItemType[];
}

export const bundleIds: BundleIdsType = {
    us: [
        {
            productId: '15386147061833',
            variantId: '54692162764873',
            subs: [
                {
                    parentVariantId: '54692162764873',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692162764873',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692162764873',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54692162797641',
            subs: [
                {
                    parentVariantId: '54692162797641',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692162797641',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54718699962441',
            subs: [
                {
                    parentVariantId: '54718699962441',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718699962441',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718699962441',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54718699995209',
            subs: [
                {
                    parentVariantId: '54718699995209',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718699995209',
                    productId: '15389745971273',
                    variantId: '54707791233097',
                },
                {
                    parentVariantId: '54718699995209',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54718700027977',
            subs: [
                {
                    parentVariantId: '54718700027977',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718700027977',
                    productId: '15389745971273',
                    variantId: '54707791233097',
                },
                {
                    parentVariantId: '54718700027977',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54718700093513',
            subs: [
                {
                    parentVariantId: '54718700093513',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718700093513',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718700093513',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '54718699995209',
            variantId: '54718700060745',
            subs: [
                {
                    parentVariantId: '54718700060745',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718700060745',
                    productId: '15389745971273',
                    variantId: '54707791233097',
                },
                {
                    parentVariantId: '54718700060745',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54692162895945',
            subs: [
                {
                    parentVariantId: '54692162895945',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692162895945',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692162895945',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386147061833',
            variantId: '54692162928713',
            subs: [
                {
                    parentVariantId: '54692162928713',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692162928713',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
    ],
    ca: [
        {
            productId: '15164532654451',
            variantId: '62531792994675',
            subs: [
                {
                    parentVariantId: '62531792994675',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62531792994675',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62531792994675',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62060638404979',
            subs: [
                {
                    parentVariantId: '62060638404979',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060638404979',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060638404979',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62106661618035',
            subs: [
                {
                    parentVariantId: '62106661618035',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106661618035',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106661618035',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62106661650803',
            subs: [
                {
                    parentVariantId: '62106661650803',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106661650803',
                    productId: '15170280161651',
                    variantId: '62084427022707',
                },
                {
                    parentVariantId: '62106661650803',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62106661683571',
            subs: [
                {
                    parentVariantId: '62106661683571',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106661683571',
                    productId: '15170280161651',
                    variantId: '62084427022707',
                },
                {
                    parentVariantId: '62106661683571',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62106661716339',
            subs: [
                {
                    parentVariantId: '62106661716339',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106661716339',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106661716339',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62060638470515',
            subs: [
                {
                    parentVariantId: '62060638470515',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060638470515',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060638470515',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62106661749107',
            subs: [
                {
                    parentVariantId: '62106661749107',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106661749107',
                    productId: '15170280161651',
                    variantId: '62084427022707',
                },
                {
                    parentVariantId: '62106661749107',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62060638503283',
            subs: [
                {
                    parentVariantId: '62060638503283',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060638503283',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060638503283',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164532654451',
            variantId: '62060638437747',
            subs: [
                {
                    parentVariantId: '62060638437747',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060638437747',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
    ],
};
